<template>
  <slot></slot>

  <modal :id="modalId" :title="title">
    <form :id="formId" :action="action" method="POST">

      <div v-if="deleting">
        <p>Are you sure you want to delete the following journal note?</p>
        <div class="card bg-well">
          <div class="card-body wrap-lines">{{ text }}</div>
        </div>
      </div>
      <div v-else-if="updatingTpa">
        <p v-if="newTpa">Are you sure you want to add the following note to the TPA journal?</p>
        <p v-if="!newTpa">Are you sure you want to remove the following note from the TPA journal?</p>
        <div class="card bg-well">
          <div class="card-body wrap-lines">{{ text }}</div>
        </div>
        <input type="hidden" name="text" v-model="text"/>
        <input type="hidden" name="tpa" v-if="newTpa" value="true"/>
      </div>
      <div v-else>
        <div class="form-group row" :class="{ 'has-error': !hasData, 'has-success': hasData }">
          <div class="col-sm-12">
            <textarea class="form-control" name="text" required="required" v-model="text" placeholder="Enter journal entry here..." rows="10"></textarea>
          </div>
        </div>

        <div class="form-group row pt-2" v-if="hasTemplates">
          <label class="col-sm-2 col-form-label">Add a template:</label>
          <div class="col-sm-10">
            <div class="input-group">
              <select class="form-control" v-model="selectedTemplate">
                <option value="">Select a template...</option>
                <option v-for="template in templates" :value="template">{{ template.name }}</option>
              </select>
              <span class="input-group-btn">
                <button class="btn btn-primary" type="button" @click="insertTemplate" :disabled="selectedTemplate == ''"><i class="fa fa-fw fa-plus-circle"></i>Add</button>
              </span>
            </div><!-- /input-group -->
          </div>
          <hr/>
        </div>
        <div class="form-group row" v-if="tpaEnabled">
          <label class="col-sm-2 col-form-label">TPA:</label>
          <div class="col-sm-10 pt-2">
            <label class="checkbox-inline">
              <input type="checkbox" name="tpa" v-model="tpa">
              Add to TPA journal
            </label>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-sm-2 col-form-label">Notify:</label>
          <div class="col-sm-10 pt-2">
            <div class="form-check form-check-inline">
              <input class="form-check-input" id="notify_team_lead" type="checkbox" name="notify_team_lead" v-model="notifyTeamLead">
              <label class="form-check-label" for="notify_team_lead">Account Manager</label>
            </div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" id="notify_adjuster" type="checkbox" name="notify_adjuster" v-model="notifyAdjuster">
              <label class="form-check-label" for="notify_adjuster">Adjuster</label>
            </div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" id="notify_examiner" type="checkbox" name="notify_examiner" v-model="notifyExaminer">
              <label class="form-check-label" for="notify_examiner">Examiner</label>
            </div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" id="notify_others" type="checkbox" name="notify_others" v-model="notifyOthers">
              <label class="form-check-label" for="notify_others">Others</label>
            </div>
          </div>
        </div>
        <div class="form-group row" v-if="notifyOthers">
          <div class="offset-sm-2 col-sm-10">
            <email-typeahead
                v-model="otherEmails"
                fieldname="other_emails"
                :allow-manage-lookup-item="allowManageLookupEmailItem"
            ></email-typeahead>
          </div>
        </div>
        <div class="form-group row mt-3" v-if="diaryDateAllowed">
          <label class="col-sm-2 col-form-label">Diary Date:</label>
          <div class="col-sm-10">
            <diary-date-select v-model="diaryDate"></diary-date-select>
          </div>
        </div>
        <div class="form-group row mt-3" :class="{ 'has-error': needsSendToCarrier }" v-if="sendsToCarrier">
          <label class="col-sm-2 col-form-label">Send to Carrier?</label>
          <div class="col-sm-10 mt-1">
            <label class="radio-inline mr-1">
              <input type="radio" name="send_to_carrier" :value="1" v-model="sendToCarrier"> Yes
            </label>
            <label class="radio-inline">
              <input type="radio" name="send_to_carrier" :value="0" v-model="sendToCarrier"> No
            </label>
          </div>
        </div>
      </div>

      <input type="hidden" name="_method" :value="method">
      <input type="hidden" name="_token" :value="$csrf_token">
    </form>

    <template #footer>
      <template v-if="deleting">
        <button type="button" class="btn btn-default" v-if="deletingInsideEdit" @click.prevent="cancelDeletionDialog"><i class="fa fa-fw fa-ban"></i> Cancel</button>
        <button type="button" class="btn btn-default" v-if="!deletingInsideEdit" @click="hideModal"><i class="fa fa-fw fa-close"></i> Close</button>
        <button type="submit" class="btn btn-danger" :form="formId"><i class="fa fa-fw fa-trash"></i> Delete</button>
      </template>
      <template v-else-if="updatingTpa">
        <button type="button" class="btn btn-default" @click="hideModal"><i class="fa fa-fw fa-ban"></i> Cancel</button>
        <button type="submit" class="btn btn-primary" v-if="newTpa" :form="formId"><i class="fa fa-fw fa-plus-circle"></i> Add to TPA Journal</button>
        <button type="submit" class="btn btn-danger" v-if="!newTpa" :form="formId"><i class="fa fa-fw fa-minus-circle"></i> Remove from TPA Journal</button>
      </template>
      <template v-else>
        <button type="button" class="btn btn-danger mr-auto" v-if="isExisting" @click.prevent="showDeletionDialog"><i class="fa fa-fw fa-trash"></i> Delete</button>
        <button type="button" class="btn btn-default" @click="hideModal"><i class="fa fa-fw fa-close"></i> Close</button>
        <button type="submit" class="btn btn-primary" :disabled="!isValid" :form="formId"><i class="fa fa-fw fa-save"></i> Save</button>
      </template>
    </template>

  </modal>

</template>

<script>
import HasModal from "./mixins/HasModal";
import EmailTypeahead from "./EmailTypeahead";
import DiaryDateSelect from "./DiaryDateSelect";

export default {
  mixins: [HasModal],

  props: {
    // Component mode, one of: add, edit, delete, update-tpa.
    initialMode: {
      required: true,
      type: String,
    },
    // Journal note ID.
    id: {
      type: Number,
      default: 0,
    },
    // Initial journal note text.
    initialText: {
      type: String,
      default: ''
    },
    // Initial TPA checkbox value (should the journal note present in TPA journal?).
    initialTpa: {
      type: Boolean,
      default: false
    },
    // Initial "Notify: Account Manager" value.
    initialNotifyTeamLead: {
      type: Boolean,
      default: false
    },
    // Initial "Notify: Adjuster" value.
    initialNotifyAdjuster: {
      type: Boolean,
      default: false
    },
    // Initial "Notify: Examiner" value.
    initialNotifyExaminer: {
      type: Boolean,
      default: false
    },
    // Initial "Notify: Others" value.
    initialNotifyOthers: {
      type: Boolean,
      default: false
    },
    // Initial other emails.
    initialOtherEmails: {
      type: String,
      default: ''
    },
    // Initial "Send to Carrier?".
    initialSendToCarrier: {
      type: Number,
      default: null,
    },
    // Custom id for modal component.
    modalId: {
      type: String,
      default: 'journal-modal'
    },
    // Form action.
    action: {
      require: true,
      type: String
    },
    // Allow user to manage lookup email list items.
    allowManageLookupEmailItem: {
      type: Boolean,
      default: false
    },
    newTpa: {
      type: Boolean,
      default: true
    },
    templates: {
      type: Array,
      default: () => {return []}
    },
    tpaEnabled: Boolean,
    diaryDateAllowed: Boolean,
    initialDiaryDate: String,
    sendsToCarrier: Boolean,
    sendToCarrierRequired: Boolean,
  },

  components: {
    'email-typeahead': EmailTypeahead,
    'diary-date-select': DiaryDateSelect
  },

  data() {
    return {
      mode: this.initialMode,
      text: this.initialText,
      tpa: this.initialTpa,
      notifyTeamLead: this.initialNotifyTeamLead,
      notifyAdjuster: this.initialNotifyAdjuster,
      notifyExaminer: this.initialNotifyExaminer,
      notifyOthers: this.initialNotifyOthers,
      otherEmails: this.initialOtherEmails,
      diaryDate: this.initialDiaryDate,
      sendToCarrier: (this.sendsToCarrier && !this.sendToCarrierRequired) ? false : this.initialSendToCarrier,
      selectedTemplate: '',
    }
  },

  computed: {
    formId() {
      return this.modalId + '-form';
    },
    title() {
      if (this.deleting) return 'Delete Journal Note';
      return this.isNew ? "Add to Journal" : "Edit Journal Note";
    },
    method() {
      if (this.deleting) return 'DELETE';
      return this.isNew ? "POST" : "PATCH";
    },
    hasData() {
      return !!(this.text && this.text.trim().length);
    },
    isEmpty() {
      return !this.hasData;
    },
    isValid() {
      return this.hasData && !this.needsSendToCarrier;
    },
    isExisting() {
      return this.id > 0;
    },
    isNew() {
      return !this.isExisting;
    },
    hasTemplates() {
      return this.templates.length > 0;
    },
    needsSendToCarrier() {
      return this.sendsToCarrier && this.sendToCarrierRequired && (typeof this.sendToCarrier !== "number");
    },
    deleting() {
      return this.mode === 'delete';
    },
    deletingInsideEdit() {
      return this.initialMode !== 'delete';
    },
    updatingTpa() {
      return this.mode === 'update-tpa';
    },
  },

  methods: {
    insertTemplate(event) {
      let str = this.text;

      if (str === undefined) {
        str = '';
      }

      let selectedTemplate = this.selectedTemplate;

      if (typeof selectedTemplate === 'object') {
        if (str.length > 0) {
          this.text = str.concat('\n', selectedTemplate.text);
        } else {
          this.text = selectedTemplate.text;
        }
      }
    },

    showDeletionDialog() {
      this.mode = 'delete';
    },

    cancelDeletionDialog() {
      this.mode = this.isNew ? 'add' : 'edit';
    },
  }
}

</script>
